import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useAccountsBillModel } from "../accountsBillModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";

export const DataBox = () => {
    const { exportSoList, descTotal } = useAccountsBillModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.STT_SL_EX}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportSoList()}
            >导出</Button>
        </YhAuth>
    </>;
    const desc: IDescription[] = [
        {
            label: "维修数量",
            value: descTotal.saleNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "维修金额",
            value: descTotal.saleAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "维修成本",
            value: descTotal.costAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "维修毛利",
            value: descTotal.profit,
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}